<template>
  <div class="sectionOuterBox bgBlue">
    <div class="sectionInnerBox">
      <v-container class="container sectionContainer headlineSectionContainer">
        <v-row>
          <v-col cols="12" md="5">
            <div class="sectionHeader headlineSectionHeader">
              <h1 class="headLineText">{{ $t('schools.headline.title') }}</h1>
              <h2 class="subText font-weight-thin">
                {{ $t('schools.headline.subtitle') }}
              </h2>
              <div>
                <a
                  class="signup"
                  :href="calendlyDemoLink"
                  target="_blank"
                  :aria-label="$t('schools.headline.demoSchedule.ariaLabel')"
                >
                  <div>{{ $t('schools.headline.demoSchedule.question') }}</div>
                  <div class="signup-num">{{ $t('schools.headline.demoSchedule.buttonText') }}</div>
                </a>
              </div>
            </div>
          </v-col>
          <v-col class="headlineImageContainer" cols="12" md="7">
            <img class="headlineImage" src="https://cdn.planbook.com/images/welcome-schools-c.png" alt="">
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Headline extends Vue {
  calendlyDemoLink = window.calendlyDemoLink;
}
</script>

<style lang="scss" scoped>
.sectionInnerBox {
  padding: 0;
}

.headlineSectionContainer {
  background-image: url('https://cdn.planbook.com/images/welcome-school-bg.jpg');
  background-size: cover;
  background-position: center;
  padding: 33px 30px;
}

.headlineImageContainer {
  position: relative;
  height: 342px;
}

@media screen and (max-width: 1199px) and (min-width: 992px) {
  .headlineImageContainer {
    top: 40px;
  }
}

@media screen and (max-width: 991px) and (min-width: 960px) {
  .headlineImageContainer {
    top: 78px;
  }
}

@media screen and (max-width: 960px) {
  .headlineImageContainer {
    height: 255px;
  }
}

@media screen and (max-width: 600px) {
  .headlineImageContainer {
    height: 140px;
  }
}

.signup {
  font-family: Raleway, Arial, Helvetica, sans-serif;
  border: 4px solid #FFFFFF;
  color: white;
  background-color: #d81632;
  padding: 14px 20px;
  font-size: 18px;
  font-weight: 500;
  border-radius: 20px;
  box-shadow: 0 0 15px #2b2b2b;
  display: inline-block;
  -moz-box-shadow: 0 0 15px #2b2b2b;
  -webkit-box-shadow: 0 0 15px #2b2b2b;
  cursor: pointer;
  text-align: center;
  text-decoration: none;
}

.signup:focus {
  outline: 2px solid #ffffff;
  outline-offset: 2px;
}

.signup > div:first-child {
  font-size: 16px;
}

.signup > div:nth-child(2) {
  font-size: 20px;
  font-weight: 600;
}
</style>
